import React, { createContext, useEffect, useReducer, useState } from 'react'
import PropTypes from 'prop-types'

export const AlertsStateContext = createContext({
    confirmCustomer: {
        isShowed: false,
        toggleClose: () => {}
    }
})

const AlertsState = ({ children }) => {
    const [isConfirmCustomerWindow, setIsConfirmCustomerWindow] = useState(false)
    const [isNeedAuthorize, setIsNeedAuthorize] = useState(false)

    const toggleIsConfirmCustomerWindow = () => {
        setIsConfirmCustomerWindow(!isConfirmCustomerWindow)
    }
    return (
        <AlertsStateContext.Provider
            value={{
                confirmCustomer: {
                    isShowed: isConfirmCustomerWindow,
                    toggleClose: toggleIsConfirmCustomerWindow
                }
            }}>
            {children}
        </AlertsStateContext.Provider>
    )
}

AlertsState.propTypes = {
    children: PropTypes.node.isRequired
}

export default AlertsState
